import {
    OVERVIEW_PATH,
    CATEGORY_CATALOG_PATH,
    MAILBOX_DETAIL_PATH,
    MAILBOX_CATEGORY_DETAIL_PATH,
    CATEGORY_CATALOG_DETAIL_PATH,
} from './constants.ts';
import CategoryDetailPage from './pages/CategoryDetailPage.tsx';
import MailboxDetailPage from './pages/MailboxDetailPage.tsx';
import OverviewPage from './pages/OverviewPage.tsx';
import { canManageSmartInbox, canSeeMailboxes } from '../../users/utils.ts';

export default [
    {
        path: OVERVIEW_PATH,
        component: OverviewPage,
        condition: ({ user }) => canSeeMailboxes(user),
    },
    {
        path: CATEGORY_CATALOG_PATH,
        component: OverviewPage,
        condition: ({ user }) => canManageSmartInbox(user),
    },
    {
        path: MAILBOX_CATEGORY_DETAIL_PATH,
        component: CategoryDetailPage,
        condition: ({ user }) => canManageSmartInbox(user),
    },
    {
        path: CATEGORY_CATALOG_DETAIL_PATH,
        component: CategoryDetailPage,
        condition: ({ user }) => canManageSmartInbox(user),
    },
    {
        path: MAILBOX_DETAIL_PATH,
        component: MailboxDetailPage,
        condition: ({ user }) => canSeeMailboxes(user),
    },
];
